export default {
  loading: 'Loading…',
  queryFailed: 'Query failed',
  notConnected: 'Not connected',
  addressUnavailable: 'Address unavailable',
  connect: 'Connecting…',
  connectMetaMask: 'Connect MetaMask',
  cancel: 'Cancel',
  close: 'Close',
  processing: 'Processing…',
  confirming: 'Confirming…',
  backgroundConfirming: 'Confirming in background',
  viewTransaction: 'View transaction: {{hash}}',
} as const;

